'use strict';

class PodcastPlayer {
    constructor() {
        if (jQuery(".podcast-audio-container").length) {
            this.audio = document.getElementById("podcast-audio");
            this.playPauseBtn = document.getElementById("podcast-play-pause-btn");
            this.progressBar = document.getElementById("podcast-audio-progress-bar");
            this.progressText = document.getElementById("podcast-label");
            this.progressContainer = document.getElementById("podcast-audio-progress-container");
            this.remainingTimeDisplay = document.getElementById("podcast-time-duration");

            this.playIcon = "/wp-content/themes/uptempo/assets/img/icons/podcast-play-icon.svg";
            this.pauseIcon = "/wp-content/themes/uptempo/assets/img/icons/podcast-pause-icon.svg";

            this.isTouching = false;
            this.startX = 0;
            this.initialTime = 0;

            this.setupEventListeners();
            this.initializePlayer();
        }
    }

    setupEventListeners() {
        document.addEventListener("DOMContentLoaded", () => {
            this.playPauseBtn.addEventListener("click", this.togglePlayPause.bind(this));
            this.progressContainer.addEventListener("click", this.seekThroughProgressBar.bind(this));
            this.audio.addEventListener("loadedmetadata", this.onAudioMetadataLoaded.bind(this));
            this.audio.addEventListener("timeupdate", this.onAudioTimeUpdate.bind(this));
            this.audio.addEventListener("ended", this.onAudioEnded.bind(this));
            this.audio.addEventListener("error", this.onAudioError.bind(this));

            // Mobile touch events
            this.progressContainer.addEventListener('touchstart', this.onTouchStart.bind(this));
            this.progressContainer.addEventListener('touchmove', this.onTouchMove.bind(this));
            this.progressContainer.addEventListener('touchend', this.onTouchEnd.bind(this));
        });
    }

    initializePlayer() {
        if (this.audio.paused) {
            this.playPauseBtn.innerHTML = `<img src="${this.playIcon}" alt="Play">`;
            this.progressContainer.style.display = "none";  // Hide progress bar
            this.progressText.style.display = "inline";  // Show text
        } else {
            this.playPauseBtn.innerHTML = `<img src="${this.pauseIcon}" alt="Pause">`;
            this.progressContainer.style.display = "block";  // Show progress bar
            this.progressText.style.display = "none";  // Hide text
        }
    }

    togglePlayPause() {
        if (this.audio.paused) {
            this.audio.play();
            this.playPauseBtn.innerHTML = `<img src="${this.pauseIcon}" alt="Pause">`;
            this.progressText.style.display = "none";  // Hide text
            this.progressContainer.style.display = "block";  // Show progress bar
        } else {
            this.audio.pause();
            this.playPauseBtn.innerHTML = `<img src="${this.playIcon}" alt="Play">`;
        }
    }

    updateProgressBar() {
        const progressPercent = (this.audio.currentTime / this.audio.duration) * 100;
        this.progressBar.style.width = progressPercent + "%";

        const remainingTime = this.audio.duration - this.audio.currentTime;
        const minutes = Math.floor(remainingTime / 60);
        const seconds = Math.floor(remainingTime % 60);
        this.remainingTimeDisplay.textContent = `${this.formatTime(minutes)}:${this.formatTime(seconds)}`;
    }

    formatTime(time) {
        return time < 10 ? `0${time}` : time;
    }

    seekThroughProgressBar(event) {
        const offsetX = event.offsetX;
        const totalWidth = this.progressContainer.offsetWidth;
        const newTime = (offsetX / totalWidth) * this.audio.duration;
        this.audio.currentTime = newTime;
    }

    onAudioMetadataLoaded() {
        this.updateProgressBar();
    }

    onAudioTimeUpdate() {
        this.updateProgressBar();
    }

    onAudioEnded() {
        this.playPauseBtn.innerHTML = `<img src="${this.playIcon}" alt="Play">`;
        this.progressText.style.display = "inline";  // Show text
        this.progressContainer.style.display = "none";  // Hide progress bar
        this.progressBar.style.width = "0%";
        const minutes = Math.floor(this.audio.duration / 60);
        const seconds = Math.floor(this.audio.duration % 60);
        this.remainingTimeDisplay.textContent = `${this.formatTime(minutes)}:${this.formatTime(seconds)}`;
    }

    onAudioError() {
        alert("Error loading audio file.");
    }

    // Touch event handlers
    onTouchStart(event) {
        this.isTouching = true;
        this.startX = event.touches[0].pageX;
        this.initialTime = this.audio.currentTime;
        this.audio.pause(); // Pause the audio when user starts dragging
    }

    onTouchMove(event) {
        if (this.isTouching) {
            const currentX = event.touches[0].pageX;
            const diffX = currentX - this.startX;
            const totalWidth = this.progressContainer.offsetWidth;
            const progressPercent = (diffX / totalWidth) * 100;

            // Update the progress bar width and the audio time based on the movement
            const newTime = this.initialTime + (progressPercent / 100) * this.audio.duration;
            if (newTime >= 0 && newTime <= this.audio.duration) {
                this.progressBar.style.width = progressPercent + "%";
                this.audio.currentTime = newTime;
            }
        }
    }

    onTouchEnd() {
        this.isTouching = false;
        this.audio.play(); // Resume playing the audio after the touch ends
    }
}